export default __webpack_public_path__ + "static/media/book1.b9c08fef.jpg";